import { schema } from 'normalizr';
import { createAction } from 'redux-api-middleware';
import { buildQueryString, handleResponse, handleError } from '../utils';

export const FETCH_TRANSACTIONS_REQUEST = 'FETCH_TRANSACTIONS_REQUEST';
export const FETCH_TRANSACTIONS_SUCCESS = 'FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_FAILURE = 'FETCH_TRANSACTIONS_FAILURE';
export const FETCH_TRANSACTIONCOUNT_REQUEST = 'FETCH_TRANSACTIONCOUNT_REQUEST';
export const FETCH_TRANSACTIONCOUNT_SUCCESS = 'FETCH_TRANSACTIONCOUNT_SUCCESS';
export const FETCH_TRANSACTIONCOUNT_FAILURE = 'FETCH_TRANSACTIONCOUNT_FAILURE';
export const SORT_TRANSACTIONS = 'SORT_TRANSACTIONS';
export const TRANSACTION_PAGE_SIZE = 50;

export const transactionSchema = new schema.Entity(
  'transactions',
  {},
  { idAttribute: 'transactionHash' },
);

/**
 * Fetch transactions related to a specific partner contract.
 *
 * @param {object} filters - Query parameters.
 * @param {string} [filters.partnerAddress] - Partner Address.
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const fetchTransactions = ({
  start = 0,
  contractAddress,
  partnerAddress,
  count = TRANSACTION_PAGE_SIZE,
  tokenId = '',
  sortField = 'actualPeriod',
  sortOrder = 'desc',
} = {}) =>
  createAction({
    endpoint: `${window.config.apiUrl}/transactions?${buildQueryString({
      start,
      count,
      contractAddress,
      partnerAddress,
      tokenId,
      sortField,
      sortOrder,
    })}`,
    method: 'GET',
    types: [
      {
        type: FETCH_TRANSACTIONS_REQUEST,
      },
      {
        type: FETCH_TRANSACTIONS_SUCCESS,
        payload: (action, state, res) => handleResponse([transactionSchema], action, state, res),
      },
      { type: FETCH_TRANSACTIONS_FAILURE, payload: handleError },
    ],
  });

export const fetchTransactionsStats = ({ contractAddress, partnerAddress, tokenId, silo } = {}) =>
  createAction({
    endpoint: `${window.config.apiUrl}/transactions/stats?${buildQueryString({
      contractAddress,
      silo,
      partnerAddress,
      tokenId,
    })}`,
    method: 'GET',
    types: [
      FETCH_TRANSACTIONCOUNT_REQUEST,
      FETCH_TRANSACTIONCOUNT_SUCCESS,
      { type: FETCH_TRANSACTIONCOUNT_FAILURE, payload: handleError },
    ],
  });

export const sortTransactions = (partnerAddress, contractAddress, page) => ({
  type: SORT_TRANSACTIONS,
  payload: page,
  meta: { partnerAddress, contractAddress },
});
